import { render, staticRenderFns } from "./SkinChipLinkScmm.vue?vue&type=template&id=a4d11b90&scoped=true&"
import script from "./SkinChipLinkScmm.vue?vue&type=script&lang=ts&"
export * from "./SkinChipLinkScmm.vue?vue&type=script&lang=ts&"
import style0 from "./SkinChipLinkScmm.vue?vue&type=style&index=0&id=a4d11b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d11b90",
  null
  
)

export default component.exports